import { Component } from '@angular/core';
import { FileClass } from './file.class';
import { FilesProvider, ImageReadyService } from './providers/';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FileViewBase } from './file.view.directive';
@Component({
  selector: 'file-view-unknown',
  template: `
    <div class="wp-overlay">
      <div class="wp-modal wp-center">
        <div style="display:block;">
          <h4>{{file.name}}</h4>
          <p>File type not able to display in browser. Please Download.</p>
        </div>
        <a class="btn" download [href]="downloadURL" target="_blank">Download Now</a>
      </div>
    </div>
  `
})
export class FileViewUnknownComponent extends FileViewBase {
  downloadURL: SafeResourceUrl;
  constructor(public fp: FilesProvider, public irs: ImageReadyService, private san: DomSanitizer) {
    super(fp, irs);
  }

  ngOnInit() {
    this.downloadURL = this.file.download(this.san);
  }
}



// WEBPACK FOOTER //
// ./src/app/file.view.unknown.ts